import React from 'react'

const WorkComponent = () => {
  return (
    <main>
      {/* Hero Area Start */}
      <div
        className="hero-area hero-height2 d-flex align-items-center"
        data-background="assets/img/hero/h2_hero.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="hero-cap text-center pt-50">
                <h2>Project Terbaru Kami</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hero Area End */}
      {/* Project Gallery Start */}
      <div className="project-gallery-area section-padding2">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="portfolio-wrapper mb-30">
                <div
                  className="portfolio-thumb small-img"
                  style={{
                    backgroundImage: 'url(/assets/images/portofolio1.png)',
                    backgroundSize: 'cover',
                  }}
                ></div>
                {/* Popup img Link */}
                <div className="portfolio-content">
                  <a href="https://dribbble.com/shots/15339320-Muslim-News">
                    Know more about{' '}
                    <span style={{ fontWeight: 'bold' }}>ARMAN.</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="portfolio-wrapper mb-30">
                <div
                  className="portfolio-thumb small-img"
                  style={{
                    backgroundImage: 'url(/assets/images/portofolio2.png)',
                    backgroundSize: 'cover',
                  }}
                ></div>
                {/* Popup img Link */}
                <div className="portfolio-content">
                  <a href="https://dribbble.com/shots/15327478-Dashboard-Point-of-Sales">
                    Know more about{' '}
                    <span style={{ fontWeight: 'bold' }}>POS.</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="portfolio-wrapper mb-30">
                <div
                  className="portfolio-thumb small-img"
                  style={{
                    backgroundImage: 'url(/assets/images/portofolio3.png)',
                    backgroundSize: 'cover',
                  }}
                ></div>
                {/* Popup img Link */}
                <div className="portfolio-content">
                  <a href="https://dribbble.com/shots/15290366-Game-App">
                    Know more about{' '}
                    <span style={{ fontWeight: 'bold' }}>Game App.</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="portfolio-wrapper mb-30">
                <div
                  className="portfolio-thumb small-img"
                  style={{
                    backgroundImage: 'url(/assets/images/portofolio4.png)',
                    backgroundSize: 'cover',
                  }}
                ></div>
                {/* Popup img Link */}
                <div className="portfolio-content">
                  <a href="https://dribbble.com/shots/15445827-Healthis-Splash-Screen">
                    Know more about{' '}
                    <span style={{ fontWeight: 'bold' }}>HEALTHIS.</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Project Gallery End */}
      {/* Want To Work Start */}
      <div className="wantToWork-area wantToWork-area2 w-padding2">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-8 col-lg-8 col-md-8">
              <div className="wantToWork-caption wantToWork-caption2">
                <h2>
                  Segera hubungi kami dan buat bisnis anda menjadi digital
                  dengan kami.
                </h2>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4">
              <a href="/contact" className="btn btn-black f-right">
                contact us now
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
    </main>
  )
}

export default WorkComponent
